import {defineStore} from 'pinia'
import {RouteLocationNormalized, RouteLocationNormalizedLoadedGeneric} from 'vue-router'
import {markRaw, ref, shallowRef} from 'vue'
import {RouteLayerType} from '@toolify/client/src/setup/router/enum/RouteLayerType'
import {IRouteLayerLocation} from '@toolify/client/src/modules/routes/types/IRouteLayerLocation'
import {shouldReplaceRouteLayerLocation} from '@toolify/client/src/modules/routes/functions/shouldReplaceRouteLayerLocation'

export const useRouteStore = defineStore('routeStore', () => {
  const lastRouteByLayer = ref<Partial<Record<RouteLayerType, IRouteLayerLocation>>>({})

  function setLastRouteForLayer(
    layer: RouteLayerType,
    location: Omit<IRouteLayerLocation, 'visitedAt'>,
  ) {
    const existing = lastRouteByLayer.value[layer]
    if(!shouldReplaceRouteLayerLocation(existing, location.depth)) {
      return
    }

    lastRouteByLayer.value = {
      ...lastRouteByLayer.value,
      [layer]: {
        ...location,
        visitedAt: Date.now(),
      },
    }
  }

  const stackableRoutes = shallowRef<RouteLocationNormalized[]>([])
  const stackableLevelDepths = shallowRef<number[]>([])
  const lastNonStackableRoute = shallowRef<RouteLocationNormalizedLoadedGeneric | null>(null)
  const historyPosition = window.history?.state?.position - 1
  const currentHistoryPosition = ref<number | null>(historyPosition ?? -1)

  function setLastNonStackableRoute(route: RouteLocationNormalizedLoadedGeneric | RouteLocationNormalized | null) {
    lastNonStackableRoute.value = route ? markRaw(route as RouteLocationNormalizedLoadedGeneric) : null
  }

  function setStackableRoutes(routes: RouteLocationNormalized[]) {
    stackableRoutes.value = routes.map(route => markRaw(route))
  }

  function setStackableLevelDepths(depths: number[]) {
    stackableLevelDepths.value = depths
  }

  return {
    lastRouteByLayer,
    setLastRouteForLayer,
    lastNonStackableRoute,
    stackableRoutes,
    stackableLevelDepths,
    currentHistoryPosition,
    setLastNonStackableRoute,
    setStackableRoutes,
    setStackableLevelDepths,
  }
})
